import { useWorkspaceContext } from "@rapid/contexts/WorkspaceContext";

export function useCurrentWorkspace() {
    const { currentWorkspace, currentWorkspaceUsage, apiKey, switchWorkspace } =
        useWorkspaceContext();
    return { currentWorkspace, currentWorkspaceUsage, apiKey, switchWorkspace };
}
